var _path, _mask, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgXls = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "#84BD5A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.30409L23.6557 10.6668H19.6183C19.093 10.6668 18.6663 10.1588 18.6663 9.53342V5.30409ZM26.321 9.77075L20.3943 3.10408C20.1423 2.82541 19.7837 2.66675 19.4077 2.66675H8.74101C6.86101 2.66675 5.33301 4.16275 5.33301 6.00008V26.0001C5.33301 27.8374 6.86101 29.3334 8.74101 29.3334H23.2583C25.1383 29.3334 26.6663 27.8374 26.6663 26.0001V10.6667C26.6663 10.3347 26.5437 10.0161 26.321 9.77075Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4444 18.1739L12.8354 16.4309C13.2514 15.8869 14.0594 16.5819 13.6034 17.1019C13.1244 17.6699 12.6204 18.2859 12.1404 18.9169L13.7714 20.9479C14.2114 21.5479 13.3324 22.1229 12.9004 21.5309L11.4284 19.6439L9.98139 21.5719C9.57339 22.1549 8.66939 21.4999 9.12539 20.9559L10.7324 18.9169C10.2284 18.2849 9.74039 17.6699 9.25339 17.1019C8.75039 16.5019 9.68539 15.8869 10.0534 16.4479L11.4444 18.1739Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7588 16.7341C14.7588 16.4701 14.9828 16.2461 15.2628 16.2461C15.5188 16.2461 15.7348 16.4711 15.7348 16.7341V20.7401H17.9098C18.6928 20.7401 18.7098 21.7871 17.9098 21.7871H15.2638C14.9838 21.7871 14.7598 21.5881 14.7598 21.3001V16.7341H14.7588Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4259 17.454C19.6099 15.902 21.9519 15.623 23.0559 16.471C23.5999 16.91 23.0239 17.606 22.5439 17.254C21.9519 16.879 20.6089 16.703 20.4409 17.533C20.2249 18.845 23.7029 18.094 23.6469 20.221C23.5909 22.252 20.6489 22.299 19.5449 21.388C19.2799 21.172 19.2889 20.821 19.4329 20.604C19.6409 20.397 19.8719 20.325 20.1449 20.549C20.7999 20.996 22.4879 21.332 22.6069 20.196C22.5039 19.014 19.1779 19.725 19.4259 17.454Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXls, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xls.751ff6b9.svg";
export { ForwardRef as ReactComponent };